module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-box"
  }, [_c('label', [_vm._v("Email/SMS Test")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.d2dId),
      expression: "d2dId"
    }],
    attrs: {
      "placeholder": "Enter D2D ID#"
    },
    domProps: {
      "value": (_vm.d2dId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.d2dId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "op-btn btn-md btn-block btn-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n    SEND EMAIL\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "op-btn btn-md btn-block btn-primary",
    on: {
      "click": _vm.submitSMS
    }
  }, [_vm._v("\n    SEND SMS\n  ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d8a66652", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8a66652","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DOthers/EmailTest.vue
// module id = 2144
// module chunks = 0